import React from 'react'
import { navigate } from 'gatsby'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'

import P8015 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-8015HD_white.png"
import P8003 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-8003HD_white.png"
import P8001 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-8001HD_white.png"
import P6014 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-6014HD_white.png"
import P6012 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-6012HD_white.png"
import P6001 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-6001HD_white.png"

import P9020 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-9020HD_white.png"
import P9010 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-9010HD_white.png"
import P9008 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.png"
import P7011 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-7011HD_white.png"
import P5907 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-5907HD_white.png"
import P5905 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-5905HD_white.png"
import P2905 from "../../assets/images/TOC_Icons/Wiki_Tiles_P-IN-2905_white.png"

const styles = {
  card: {
    display: 'flex',
    marginBottom: 10,
    cursor: 'pointer',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    minWidth: 75,
    height: 75,
    margin: '20px 10px 0 10px'
  },
}

function TOCList(props) {
  const { classes } = props;

  return (
    <React.Fragment>
      <div onClick={() => navigate('/FAQs/IN-9020FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-9020FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P9020}
            title="IN-9020 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-9020 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-9020 HD is the first INSTAR Outdoor IP Surveillance PTZ camera, utilizing our new Panasonic 1080p / fullHD image sensor and an Panasonic PIR sensor.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-9010FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-9010FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P9010}
            title="IN-9010 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-9010 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-9010 HD is the first INSTAR Outdoor IP Surveillance PTZ camera, utilizing our new Panasonic 1080p / fullHD image sensor.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-9008FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-9008FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P9008}
            title="IN-9008 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-9008 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-9008 HD is the first INSTAR Outdoor IP Surveillance camera, utilizing our new Panasonic 1080p / fullHD image sensor.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-8015FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-8015FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P8015}
            title="IN-8015 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-8015 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-8015 FHD is the first INSTAR camera with the new 1080p chipset. It offers all the advantages of the IN-6014 HD with a revised software and much more.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-8003FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-8003FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P8003}
            title="IN-8003 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-8003 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-8003 FHD is the first INSTAR camera with the new 1080p chipset. The weather proof housing allows you to install it both indoor and outdoor.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-8001FHD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-8001FHD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P8001}
            title="IN-8001 Full HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-8001 Full HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-8001 FHD is the IN-6001 HD successor with the new 1080p chipset. With it&apos;s &quot;invisible&quot; IR LEDs it is ideal for use as a baby monitor.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-7011HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-7011HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P7011}
            title="IN-7011 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-7011 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-7011 HD is a weather proof dome camera which can be used inside and outside. A motor allows for change of the lenses viewing direction.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-6014HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-6014HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P6014}
            title="IN-6014 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-6014 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-6014 HD offers all the advantages of the IN-6012 HD. But also has a 80 ° wide-angle lens and an integrated PIR motion detector.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-6012HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-6012HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P6012}
            title="IN-6012 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-6012 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-6012HD is the standard HD PTZ camera for indoor surveillance. It has a standard lens with 40 ° viewing angle and IR night vision.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-6001HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-6001HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P6001}
            title="IN-6001 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-6001 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The successor of the IN-3001 VGA camera - compact, inconspicuous, IR night vision capable with a video resolution of 720p HD and integrated SD card.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-5907HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-5907HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P5907}
            title="IN-5907 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-5907 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                The IN-5907 HD is weather proof and wireless outdoor camera. Thanks to the built-in high-powered infrared diodes you can see deep into the night.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/IN-5905HD/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/IN-5905HD/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P5905}
            title="IN-5905 HD"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">IN-5905 HD</Typography>
              <Typography variant="caption" color="textSecondary">
                Looking for a small outdoor camera? The all new IN-5905HD, basically a drastically smaller version of our flagship model IN-5907HD is what you are looking for!
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
      <div onClick={() => navigate('/FAQs/VGA_Series/')} role='button' tabIndex={-1} onKeyDown={() => navigate('/FAQs/VGA_Series/')}>
        <Card className={classes.card}>
          <CardMedia
            className={classes.cover}
            image={P2905}
            title="VGA Serie"
          />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="h6">VGA Series</Typography>
              <Typography variant="caption" color="textSecondary">
                Frequently asked question about our camera models with VGA resolution.
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
}

TOCList.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(TOCList)